import { render, staticRenderFns } from "./PaymentList.vue?vue&type=template&id=3ef170bd&scoped=true"
import script from "./PaymentList.vue?vue&type=script&lang=ts"
export * from "./PaymentList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef170bd",
  null
  
)

export default component.exports